import inputHeights from "./inputHeights";

const { md } = inputHeights;

export default {
  height: md,
};
